<template>
  <el-dialog width="82%" :visible.sync="visible">
    <div class="comboChoose">
    <div class="choose">
      <el-collapse v-model="activeName" accordion >
        <el-collapse-item title="基本信息" name="1">
          <el-radio v-model="chooseValue"  border v-for="(item) in total " :key="item.name" :label="item.name" @change="change">{{item.label}}</el-radio>
        </el-collapse-item>
        <el-collapse-item title="环境信息" name="2">
          <el-radio v-model="chooseValue"  border v-for="(item) in env " :key="item.name" :label="item.name" @change="change">{{item.label}}</el-radio>
        </el-collapse-item>
        <el-collapse-item title="道路信息" name="3">
          <el-radio v-model="chooseValue"  border v-for="(item) in road " :key="item.name" :label="item.name" @change="change">{{item.label}}</el-radio>
        </el-collapse-item>
        <el-collapse-item title="参与方信息(车)" name="4">
          <el-radio v-model="chooseValue"  border v-for="(item) in car " :key="item.name" :label="item.name" @change="change">{{item.label}}</el-radio>
        </el-collapse-item>
        <el-collapse-item title="参与方信息(二轮车)" name="5">
          <el-radio v-model="chooseValue"  border v-for="(item) in twoWheel" :key="item.name" :label="item.name" @change="change">{{item.label}}</el-radio>
        </el-collapse-item>
        <el-collapse-item title="参与方信息(人)" name="6">
          <el-radio v-model="chooseValue"  border v-for="(item) in person " :key="item.name" :label="item.name" @change="change">{{item.label}}</el-radio>
        </el-collapse-item>
      </el-collapse>
    </div>

    <div class="sureButton">
      <el-button type="primary" @click="close" >取消选择</el-button>
      <el-button type="primary" @click="save" :disabled="disabled">确认保存</el-button>
    </div>
  </div>

  </el-dialog>
</template>

<script>
  import bus from './bus'
    export default {
      name: "dataDialog",
      data() {
        return {
          /*显示哪一部分的筛选选项*/
          activeName: '1',
          /*是否显示*/
          visible:false,
          /*限制提交*/
          disabled:true,
          /*单选框最后的值*/
          chooseValue:'',
          /*每一部分对应的可选值*/
          total: [
            {label: '委托号', name: 'commissionNumber'},
            {label: '参与方总数', name: 'participantsNum'},
            {label: '事故形态', name: 'accidentForm'},
            {label: '事故具体类型', name: 'accidentType'},
            {label: '障碍物类型', name: 'obstacleType'},
            {label: '天网及其他视频', name: 'otherVideo'},
            {label: '事故分类', name: 'classificationOfAccidents'},
            {label: '参与方类别', name: 'typeOfParticipants'},
          ],
          env: [
            {label: '路段信息', name: 'roadInformation'},
            {label: '天气', name: 'weather'},
            {label: '事故发生时段', name: 'periodOfAccident'},
            {label: '照明情况', name: 'lightingSituation'},
          ],
          road: [
            {label: '道路行政等级', name: 'administrativeRankOfRoad'},
            {label: '公路等级', name: 'classOfRoad'},
            {label: '城市道路类型', name: 'typeOfCityRoad'},
            {label: '整体机动车道数', name: 'totalNumberOfMotorVehicleLanes'},
            {label: '道路的线形', name: 'theLinearShapeOfTheRoad'},
            {label: '沿道路方向的趋势', name: 'trendsAlongTheRoad'},
            {label: '对向机动车道隔离形式', name: 'isolationFormOfOppositeVehicleLane'},
            {label: '最高允许车速', name: 'maximumAllowedSpeed'},
            {label: '路面材料', name: 'typeOfRoadSurface'},
            {label: '道路表面污染', name: 'surfaceFouling'},
            {label: '路表潮湿度', name: 'roadSurfaceHumidity'},
            {label: '路面状况', name: 'roadCondition'},
            {label: '交通标志是否被遮挡', name: 'trafficSignsNotVisible'},
            {label: '路口信号灯', name: 'intersectionSignalLamp'},
            {label: '路灯是否开启', name: 'streetLighting'},
            {label: '影响视线障碍物', name: 'viewObstacle'},
            {label: '交通限速设施', name: 'trafficSpeedLimitingFacilities'},
            {label: '是否为变宽路段', name: 'whetherItIsAWidenedSection'},
            {label: '是否有为变窄路段', name: 'whetherThereANarrowSection'},
            {label: '是否有遂道', name: 'whetherThereATunnel'},
            {label: '是否为匝道口', name: 'whetherItARamp'},
          ],
          car: [
            {label: '车辆类型', name: 'typeOfParticipantCar'},
            {label: '行驶方向', name: 'directionOfDriving'},
            {label: '驾驶员年龄', name: 'driverAge'},
            {label: '驾驶员性别', name: 'driverGender'},
            {label: '驾驶员是否分心', name: 'isTheDriverDistracted'},
            {label: '驾驶员心理问题', name: 'driverPhysiology'},
            {label: '是否有优先权', name: 'whetherThereAPriority'},
            {label: '道路方向', name: 'roadDirection'},
            {label: '行车记录仪数据', name: 'vehicleRecordData'},
            {label: 'EDR数据', name: 'edrData'},
            {label: '是否有视野盲区', name: 'blindAreaOutsideCar'},
            {label: '车辆初始速度(km/h)', name: 'normalDrivingSpeedBeforeVehicleCollision'},
            {label: '碰撞时速度(km/h)', name: 'collisionVelocity'},
          ],
          twoWheel: [
            {label: '二轮车种类', name: 'typeOfParticipantTwoWheel'},
            {label: '二轮车颜色', name: 'participantColorTwoWheel'},
            {label: '二轮车人员年龄', name: 'ageTwoWheel'},
            {label: '性别', name: 'genderTwoWheel'},
            {label: '是否为电动车', name: 'electricVehicleOrNot'},
            {label: '是否戴头盔', name: 'wearHelmet'},
            {label: '二轮车运动方向', name: 'twoWheelerMovementDirection'},
            {label: '二轮车速度(km/h)', name: 'twoWheelSpeed'},
            {label: '事故时车灯是否开启', name: 'whetherTurnSignalOfTwoWheeledVehicleTurned'},
            {label: '二轮车乘客数', name: 'numberPassengersOnTwoWheelers'},
            {label: '与车辆行驶方向的关系', name: 'relationOfDrivingDirection'},
          ],
          person: [
            {label: '行人被撞部位', name: 'pedestrianBeingHit'},
            {label: '年龄', name: 'agePerson'},
            {label: '性别', name: 'genderPerson'},
            {label: '身高(cm)', name: 'vehHight'},
            {label: '衣着颜色', name: 'participantColorPerson'},
            {label: '事故发生地点', name: 'accidentLocation'},
            {label: '行人穿越机动车道位置', name: 'pedestrianCrossingTheMotorwayLocation'},
            {label: '行人行走方向', name: 'pedestrianWalkingDirection'},
            {label: '行人运动状态', name: 'pedestrianMovement'},
            {label: '行人相对于车辆的位置', name: 'positionOfPedestrianRelativeToVehicleBeforeCollision'},
            {label: '黑暗处或夜间衣物可见性', name: 'visibilityInTheDarkOrAtNight'},
            {label: '停靠车辆造成视野盲区', name: 'whetherBlindareaOfPedestrianIsCausedByParkedVehicle'},
            {label: '其他造成视线盲区的物体', name: 'areThereOtherObjectsThatCausePedestrianBlindSpots'}
          ],
        }
      },
      methods : {
        /*关闭弹窗*/
        close(){
          this.visible = false;
        },
        /*选择了值才能下一步*/
        change(){
          this.disabled = false;
        },
        /*保存*/
        save () {
          /*对应值和对应表格的01码*/
          let filedCode = '';
          let tableCode = 1000000;
          this.total.forEach((item,index)=>{
            if(this.chooseValue === item.name){
              filedCode += '1';
              tableCode += 100000;
            }
            else{
              filedCode += '0';
            }
          });
          this.env.forEach((item,index)=>{
            if(this.chooseValue === item.name){
              filedCode += '1';
              tableCode += 10000;
            }
            else{
              filedCode += '0';
            }
          });
          this.road.forEach((item,index)=>{
            if(this.chooseValue === item.name){
              filedCode += '1';
              tableCode += 1000;
            }
            else{
              filedCode += '0';
            }
          });
          this.car.forEach((item,index)=>{
            if(this.chooseValue === item.name){
              filedCode += '1';
              tableCode += 100;
            }
            else{
              filedCode += '0';
            }
          });
          this.person.forEach((item,index)=>{
            if(this.chooseValue === item.name){
              filedCode += '1';
              tableCode += 10;
            }
            else{
              filedCode += '0';
            }
          });
          this.twoWheel.forEach((item,index)=>{
            if(this.chooseValue === item.name){
              filedCode += '1';
              tableCode += 1;
            }
            else{
              filedCode += '0';
            }
          });
          /*对应表格的01码*/
          //将数据转换为字符串
          tableCode = String(tableCode);
          //截取掉第一位
          tableCode = tableCode.slice(1,7);
          bus.$emit('filedCode',filedCode);
          bus.$emit('tableCode',tableCode);
          bus.$emit('sendData',this.chooseValue);
          this.chooseValue = '';
          this.visible = false;
        },
      },
      mounted () {
        bus.$on('chooseData',(msg)=>{
          this.visible = msg;
        })
      },
      beforeDestroy(){
        bus.$off('chooseData');
        bus.$off('sendData');
      }
    }
</script>

<style scoped>
  .comboChoose{
    width: 100%;
    height: 100%;
  }
  .choose{
    margin-left: 2%;
    width: 98%;
    height: 90%;
    overflow-y: auto;
  }
  .sureButton{
    margin-left: 70%;
    margin-top: 2%;
    width: 20%;
    height: 10%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .el-collapse-item__content{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .el-radio{
    width: 200px;
    margin-top: 10px;
    margin-left: 10px;
  }
</style>

<style>
  .comboChoose .el-checkbox{
    margin-left: 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/statistics/dataDialog.vue